import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';

import { APPLE_PAY, CB, GOOGLE_PAY, PAYPAL } from '../../../constants/paymentMethods';
import { PAYPAL_OPTIONS } from '../../../services/paypal/constants';

import PaypalButton from './PaypalButton';
import ApplePayButton from './ApplePayButton';
import NextStepButton from './NextStepButton';
import GooglePayButton from './GooglePayButton';
import CheckoutFlowPayButton from '../payment-step/checkout-flow/CheckoutFlowPayButton';

import { ButtonWrapper } from './ButtonContainerStyle';

const ValidationButton = ({
    setStateOfTransaction,
    paymentType,
    cartTotalValue,
    userInfo,
    partnerId,
    order,
    kycNeeded,
    checkoutAllowed
}) => {
    const showNextStepButton =
        !paymentType || (paymentType === CB && !checkoutAllowed);
    const showCheckoutPayButton = paymentType === CB && checkoutAllowed;
    const showApplePayButton = [APPLE_PAY].includes(paymentType);
    const showGooglePayButton = [GOOGLE_PAY].includes(paymentType);
    const showPaypalButton = [PAYPAL].includes(paymentType);

    return (
        <ButtonWrapper>
            {showNextStepButton && (
                <NextStepButton
                    paymentType={paymentType}
                    setStateOfTransaction={setStateOfTransaction}
                />
            )}

            {showCheckoutPayButton && <CheckoutFlowPayButton />}

            {showApplePayButton && (
                <ApplePayButton
                    userInfo={userInfo}
                    partnerId={partnerId}
                    cartTotalValue={cartTotalValue}
                    order={order}
                />
            )}

            {showGooglePayButton && (
                <GooglePayButton
                    userInfo={userInfo}
                    partnerId={partnerId}
                    cartTotalValue={cartTotalValue}
                />
            )}

            {showPaypalButton && (
                <PayPalScriptProvider options={PAYPAL_OPTIONS}>
                    <PaypalButton userInfo={userInfo} partnerId={partnerId} kycNeeded={kycNeeded} />
                </PayPalScriptProvider>
            )}
        </ButtonWrapper>
    );
};

ValidationButton.propTypes = {
    setStateOfTransaction: PropTypes.func,
    paymentType: PropTypes.string,
    cartTotalValue: PropTypes.number,
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    order: PropTypes.object,
    kycNeeded: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        checkoutAllowed:
            state.ebon.ebons.ebonPaymentConfig && state.ebon.ebons.ebonPaymentConfig.checkoutAllowed
    };
};

export default connect(mapStateToProps)(ValidationButton);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/ButtonContainer.js